import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import ContentContainer from '../common/ContentContainer';
import { useProductLoad } from '../../hooks/application';
import Loader from '../common/Loader';
import { Outlet } from 'react-router-dom';

const Product = () => {
    const productLoading = useSelector((state: ApplicationState) => state.product.productLoading);
    useProductLoad();

    return (
        <ContentContainer>
            <Loader loading={productLoading} margin={10}>
                <Outlet />
            </Loader>
        </ContentContainer>
    );
};

export default Product;
